import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  DashboardSection,
  DashboardWrapper,
  StyleElementContainer,
} from "../styles/dashboardStyles";
import styled from "styled-components";
import StyleElement from "../components/StyleElement";
import { device } from "../utils/breakpoints";
import HomeLayout from "../layouts/HomeLayout";
import { HeaderSubtitle, HeaderTitle } from "../styles/sharedStyles";
import EventCard from "../components/EventCard";
import EnterEmailBanner from "../components/Banners/EnterEmailBanner";
import MetaTags from "../components/MetaTags";
import PastEventCard from "../components/PastEventCard";
import { colors } from "../utils/theme";

const PublicEvents = () => {
  const { t } = useTranslation();
  const allEvents = useSelector(
    (state) => state.firestoreReducer.ordered.events,
  );

  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [expandedCardId, setExpandedCardId] = useState(null);

  useEffect(() => {
    if (!allEvents) {
      return;
    }
    const upComingEvents = [];
    const pastEvents = [];

    allEvents.forEach((item) => {
      if (item.type === "event" && item.private === false) {
        if (dayjs.unix(item.startDate).isSameOrAfter(dayjs())) {
          upComingEvents.push(item);
        } else {
          pastEvents.push(item);
        }
      }
    });
    setUpcomingEvents(upComingEvents);
    setPastEvents(pastEvents.reverse().slice(0, 12));
  }, [allEvents]);

  const handleCardExpand = (eventId) => {
    setExpandedCardId(expandedCardId === eventId ? null : eventId);
  };

  return (
    <HomeLayout>
      <MetaTags
        title={t("meta.events_title")}
        description={t("meta.events_description")}
        keywords={t("meta.events_keywords")}
        path="/evenementen"
        imageUrl={"public/assets/images/impression/1600x1146-ow-by-night.webp"}
      />
      <DashboardWrapper>
        <DashboardSection>
          <HeaderWrapper>
            <HeaderTitle>{t("upcoming_events")}</HeaderTitle>
            <HeaderSubtitle>
              {t(
                upcomingEvents.length > 0
                  ? "check_the_schedule"
                  : "no_upcoming_events_found",
              )}
            </HeaderSubtitle>
          </HeaderWrapper>
          <EventsGrid>
            {upcomingEvents
              .filter((event) => event.private === false)
              .map((event) => (
                <EventCard
                  key={event.id}
                  event={event}
                  isExpanded={expandedCardId === event.id}
                  onExpand={() => handleCardExpand(event.id)}
                />
              ))}
          </EventsGrid>
        </DashboardSection>
      </DashboardWrapper>
      <DashboardWrapper>
        <DashboardSection>
          <StyledH2>{t("past_events")}</StyledH2>
          <PastEventsGrid>
            {pastEvents.map((event) => (
              <PastEventCard key={event.id} event={event} />
            ))}
          </PastEventsGrid>
        </DashboardSection>
      </DashboardWrapper>
      <StyleElementContainer>
        <StyleElement
          src={"/assets/images/illustrations/illustratie-14.svg"}
          alt={""}
          bottom={-20}
          right={-13}
        />
      </StyleElementContainer>
      <EnterEmailBanner />
    </HomeLayout>
  );
};

const HeaderWrapper = styled.div`
  margin-bottom: 2rem;
`;

const EventsGrid = styled.div`
  z-index: 1;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
`;

const PastEventsGrid = styled(EventsGrid)`
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
`;

const StyledH2 = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${colors.primaryMedium};
`;

export default PublicEvents;
